var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 12",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.703926 5.72969C0.764863 5.48188 0.829863 5.23782 0.987051 5.02626C1.4958 4.34126 2.48736 4.22938 3.12424 4.79626C3.31549 4.96657 3.49143 5.15344 3.67268 5.33469C4.45486 6.11626 5.23674 6.89844 6.01861 7.68001C6.05486 7.71626 6.09236 7.75063 6.16236 7.81751C6.19893 7.76376 6.22455 7.71001 6.26424 7.67001C8.42424 5.50782 10.5852 3.34626 12.7467 1.18532C13.2689 0.663443 13.9989 0.563443 14.5939 0.92813C15.3442 1.38782 15.5117 2.43938 14.9408 3.10907C14.8946 3.16313 14.8452 3.21438 14.7949 3.26469C12.2749 5.78501 9.75361 8.30438 7.23549 10.8269C6.88924 11.1738 6.48518 11.3509 5.99424 11.3075C5.68361 11.28 5.40643 11.165 5.17236 10.955C5.10893 10.8981 5.0483 10.8378 4.98768 10.7772C3.78955 9.57938 2.5958 8.37688 1.39049 7.18594C1.05986 6.85938 0.770176 6.52157 0.703613 6.04282C0.703926 5.93844 0.703926 5.83407 0.703926 5.72969Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.b101396758b1778ba7dd294b72f5c674.svg";
export { ForwardRef as ReactComponent };